import React from 'react';
import { Box, Typography } from '@mui/material';
import MarqitLogoFull from './MarqitLogoFull';
import LegalFooter from './LegalFooter';

// Shared shell for the public auth pages (register, email confirmation).
const AuthLayout = ({ subtitle, children }) => (
  <Box
    sx={{
      minHeight: '100vh',
      background: 'linear-gradient(145deg, #EAFBFA 0%, #DFF7F6 40%, #f0fafa 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
      p: 2,
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '-10%',
        right: '-5%',
        width: '40vw',
        height: '40vw',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(25,198,192,0.12) 0%, transparent 70%)',
        pointerEvents: 'none',
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: '-10%',
        left: '-5%',
        width: '35vw',
        height: '35vw',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(25,198,192,0.08) 0%, transparent 70%)',
        pointerEvents: 'none',
      },
    }}
  >
    <Box
      sx={{
        background: '#fff',
        borderRadius: '28px',
        boxShadow: '0 24px 80px rgba(25,198,192,0.12), 0 4px 16px rgba(0,0,0,0.06)',
        border: '1px solid rgba(25,198,192,0.1)',
        p: { xs: 3, sm: 5 },
        width: '100%',
        maxWidth: 420,
        position: 'relative',
        zIndex: 1,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 4 }}>
        <Box sx={{ mb: 2.5 }}>
          <MarqitLogoFull width={210} />
        </Box>
        <Typography sx={{ color: '#6B7280', fontSize: '0.9375rem', fontWeight: 500 }}>
          {subtitle}
        </Typography>
      </Box>

      {children}
    </Box>
    <LegalFooter sx={{ mt: 3, maxWidth: 520, position: 'relative', zIndex: 1 }} />
  </Box>
);

export default AuthLayout;
